// import ResizableBox from "../ResizableBox";
import React, {useEffect, useRef, useState} from "react";
import CanvasJSReact from '../canvasjs.react';
import DropableLabel from "./DropableLabel";
import CorrectIcon from "../images/CorrectIcon.svg"
import InCorrectIcon from "../images/incorrectIcon.svg"
import "animate.css/animate.css";
import questionsAnswers from "../containers/questionAnswers"
import supplyIcon from "../images/Supply.svg"
import SocialValue from "../images/Social-value_1.svg"
import DemandIcon from "../images/Demand.svg"
import { Grid, Typography } from "@material-ui/core";
import Internationl2 from "./Internationl2";
import styles from "./BubbleLine1Styles";
import withStyles from "@material-ui/core/styles/withStyles";
import { isMobile, isTablet } from "react-device-detect";
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const BubbleAndLine6 = (props) => {
  const [allCorrect, setAllCorrect] =useState(false)
  const { qIndex, handleReloadClick, classes } = props;
  const [chartData, setChartData] =useState([])
  const [submit, setSubmit] =useState(false)
  const [onSelect, setOnSelect] = useState(-1);
  const [selected, setSelected] = useState([]);
  const canvasRef = useRef(null);

  // State to keep track of the selected option
  const [selectedParagraph, setSelectedParagraph] = useState("");

  // Define the letters for each option
  const optionLabels = ['a.', 'b.', 'c.'];

  let data = [
    {
      type: "line",
      color: 'transparent',
      dataPoints: []
    },
    {
      type: "line",
      color: "#8C479B",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 320, y: 5,  markerType: 'none', markerSize: 0 , z: 3}, {x: 105, y: 220, markerType: 'none', markerSize: 0 , z: 3}]
    },
    {
      type: "line",
      color: '#00b1d9',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 220, y: 5, markerType: 'none', markerSize: 0 , z: 1}, {x: 10, y: 215, markerType: 'none', markerSize: 0 , z: 1}]
    },
    {
      type: "line",
      color: '#003e4c',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 130, y: 5, markerType: 'none', markerSize: 0 }, {x: 320, y: 195, markerType: 'none', markerSize: 0 }]
    },
    // Ps, A-bottom
    {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 0, y: 150, markerType: 'none', markerSize: 0 }, {x: 175, y: 150, markerType: 'none', markerSize: 0 }]
    },
    // e-left
    {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 175, y: 150, markerType: 'none', markerSize: 0 }, {x: 175, y: 100, markerType: 'none', markerSize: 0 }]
    },
    // c bottom
    {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 0, y: 100, markerType: 'none', markerSize: 0 }, {x: 125, y: 100, markerType: 'none', markerSize: 0 }]
    },
    // d bottom
    {
      type: "spline",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 125, y: 100, markerType: 'none', markerSize: 0 }, {x: 175, y: 100, markerType: 'none', markerSize: 0 }]
    },
    // e-bottom
    {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 175, y: 100, markerType: 'none', markerSize: 0 }, {x: 225, y: 100, markerType: 'none', markerSize: 0 }]
    },
    // i-left
    {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 175, y: 100, markerType: 'none', markerSize: 0 }, {x: 175, y: 50, markerType: 'none', markerSize: 0 }]
    },
     //g-bottom
     {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 0, y: 50, markerType: 'none', markerSize: 0 }, {x: 175, y: 50, markerType: 'none', markerSize: 0 }]
    },
    // N-left
    {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 175, y: 0, markerType: 'none', markerSize: 0 }, {x: 175, y: 50, markerType: 'none', markerSize: 0 }]
    },
    // n-right
    {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 225, y: 0, markerType: 'none', markerSize: 0 }, {x: 225, y: 100, markerType: 'none', markerSize: 0 }]
    },
    // // C-Right
    // {
    //   type: "spline",
    //   color: '#003e4c',
    //   lineDashType: "shortDash",
//         lineThickness: isMobile ? 3 : 5,
    //   dataPoints: [{x: 150, y: 21, markerType: 'none', markerSize: 0 }, {x: 150, y: 30, markerType: 'none', markerSize: 0 }]
    // },
    // // Qs
    // {
    //   type: "spline",
    //   color: '#003e4c',
    //   lineDashType: "shortDash",
//       lineThickness: isMobile ? 3 : 5,
    //   dataPoints: [{x: 100, y: 14, markerType: 'none', markerSize: 0 }, {x: 100, y: 0, markerType: 'none', markerSize: 0 }]
    // },
    // // Qm
    // {
    //   type: "spline",
    //   color: '#003e4c',
    //   lineDashType: "shortDash",
//      lineThickness: isMobile ? 3 : 5,
    //   dataPoints: [{x: 150, y: 19, markerType: 'none', markerSize: 0 }, {x: 150, y: 0, markerType: 'none', markerSize: 0 }]
    // },
  ]

  useEffect(() => {
    setChartData(data)
  }, [])

  useEffect(() => {
    // if(submit === true){
    //   setAllCorrect(questionsAnswers[qIndex].answer === selectedParagraph)
    // }
  },[submit])

  const options = {
    colorSet: "colorSet2",
    cursor: "pointer",
    title: {
      text: isMobile ? "" : "Supply of Snow Globes",
      fontColor: "#transparent",
      // fontColor: "#003e4c",
      fontFamily: "Rubik",
      fontWeight: "bold",
      fontSize: 24,
    },
     axisX:{
      lineColor: "#003e4c",
      lineThickness: 3,
      gridThickness: 0,
      gridColor: "#cecece",
      labelFontColor: isMobile ? "transparent" : "#003e4c",
      labelFontSize: isMobile ? 2 : 0,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      interval: questionsAnswers[qIndex].step,
      minimum: 0,
      maximum: questionsAnswers[qIndex].xmax,
      labelFormatter: function(e) {
        return e.value % 2 === 0 ? e.value : "";
      }
    },
    axisY:{
      lineColor: "#003e4c",
      lineThickness: 3,
      labelFontSize: isMobile ? 2 : 0,
      labelFontFamily: "Rubik",
      gridThickness: 0,
      labelFontColor: isMobile ? "transparent" : "#003e4c",
      gridColor: "#cecece",
      interval:  questionsAnswers[qIndex].stepY,
      minimum: 0,
      maximum: questionsAnswers[qIndex].ymax,
      margin: 10
    },
    toolTip: {
      enabled: false,
    },
    data: chartData,
    height: isMobile ? 200 : 400,
    width: isMobile ? 320 : 490,
  }

  function getButtonText() {
    if(submit){
      return allCorrect ? "Next" : "Try Again"
    }else{
      return "Submit"
    }
  }

  const clearScreen = () => {
    setSubmit(false)
    setSelectedParagraph("")
    setSelected([])
    data[4].color = "#003e4c"
    data[9].color = "#003e4c"
    data[6].color = "#003e4c"
    data[7].color = "#003e4c"
    data[8].color = "#003e4c"
    setChartData(data)
  }

  function submitButtonAction() {
    if(submit){
      if(!allCorrect){
        clearScreen()
      }
    }else{
      setSubmit(true)
    }
  }

  const markSelected = (triangle) => {
    if (!submit) {
      setOnSelect(1);
      let temp = selected;
      if (selected.includes(triangle)) {
        const index = temp.indexOf(triangle);
        // if (index > -1) {
        temp.splice(index, 1);
        // }
        // temp.pop(triangle);
        setSelected(temp);
      } else {
        temp.push(triangle);
        setSelected(temp);
      }

      // const duplicateData = { ...data }
      if (selected.includes(1)) {
        data[5].color = "#00b1d9"
      } else {
        data[5].color = "#003e4c"
      }

      if (selected.includes(2)) {
        data[9].color = "#00b1d9"
      } else {
        data[9].color = "#003e4c"
      }

      if (selected.includes(3)) {
        data[12].color = "#00b1d9"
      } else {
        data[12].color = "#003e4c"
      }

      if (selected.includes(4)) {
        data[11].color = "#00b1d9"
      } else {
        data[11].color = "#003e4c"
      }

      if (selected.includes(6)) {
        data[10].color = "#00b1d9"
      } else {
        data[10].color = "#003e4c"
      }

      if (selected.includes(1) || selected.includes(2)) {
        data[8].color = "#00b1d9"
      }else {
        data[8].color = "#003e4c"
      }
      setChartData(data)

      // if (!submitted && selected.includes(4) && selected.includes(9)) {
      //   setHorBlueHalf1(true);
      // } else {
      //   setHorBlueHalf1(false);
      // }

      // if (!submitted && selected.includes(5) && selected.includes(10)) {
      //   setHorBlueHalf2(true);
      // } else {
      //   setHorBlueHalf2(false);
      // }

      // if (!submitted && selected.includes(7) && selected.includes(8)) {
      //   setVerBlue7(true);
      // } else {
      //   setVerBlue7(false);
      // }

      // if (!submitted && selected.includes(9) && selected.includes(10)) {
      //   setVerBlueHalf4(true);
      // } else {
      //   setVerBlueHalf4(false);
      // }

      // if (!submitted && selected.includes(11) && selected.includes(12)) {
      //   setVerBlueHalf5(true);
      // } else {
      //   setVerBlueHalf5(false);
      // }

      // if (!submitted && selected.includes(12) && selected.includes(13)) {
      //   setVerBlue6(true);
      // } else {
      //   setVerBlue6(false);
      // }

      // if (!submitted && selected.includes(13) && selected.includes(14)) {
      //   setVerBlueHalf8(true);
      // } else {
      //   setVerBlueHalf8(false);
      // }
    }
  };

  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.leftContainer4}>
          <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", paddingTop: "15%", paddingLeft: "5%" }}>
           <div style={{ display: "flex", flexDirection: "column", width: "90%", alignItems: "flex-start" }}>
           <h3 className={classes.questionText6}>{questionsAnswers[qIndex].question}</h3>
          {submit && 
            <div className={classes.answerTextContainer}>
              {!allCorrect ?
                <Grid container className={classes.incorrectAnswerContainer}>
                  <img src={InCorrectIcon} alt="InCorrectIcon" className={classes.icon}/>
                  <Typography className={classes.answerText}>
                  For all units between Q<sub>m</sub> to Q<sub>e</sub>, the social value exceeds the cost of producing the vaccine. The deadweight loss represents the positive transactions that society misses out on if production remains at the market equilibrium.
                  </Typography>
                </Grid>
              : 
              <Grid container className={classes.correctAnswerContainer}>
                  <img src={CorrectIcon} alt="CorrectIcon" className={classes.icon}/>
                  <Typography className={classes.answerText}>
                  For all units between Q<sub>m</sub> to Q<sub>e</sub>, the social value exceeds the cost of producing the vaccine. The deadweight loss represents the positive transactions that society misses out on if production remains at the market equilibrium.
                  </Typography>
                </Grid>
              }
            </div>
            }
           </div>
          </div>
        </div>
        <div className={`animate__animated animate__bounceIn ${classes.rightContainer}`}>
          <p className={classes.graphTitle}>{questionsAnswers[qIndex].title}</p>
          <div className={classes.labelsContainer6}>
            <DropableLabel
              right={isMobile ? "-19%" : '-15%'}
              marginTop={"5%"}
              rotate={"rotate(270deg)"}
              label={"PRICE"}
            />
            {/* <h4 style={{ position: "absolute", zIndex: 10, color: "#003e4c", fontSize: 22, fontWeight: "bold",  left: -30, top: 150 }}>P<sub>s</sub></h4>
            <h4 style={{ position: "absolute", zIndex: 10, color: "#003e4c", fontSize: 22, fontWeight: "bold",  left: -30, top: 190 }}>P<sub>m</sub></h4> */}
            {/* <h4 style={{  }}>Q<sub>m</sub></h4>
            <h4 style={{  }}>Q<sub>e</sub></h4> */}
            <h4 className={classes.Qm6}>Q<sub>m</sub></h4>
            <h4 className={classes.Qe6}>Q<sub>e</sub></h4>
            <img src={SocialValue} alt="" className={classes.socialCostIcon6} />
            <img src={supplyIcon} alt="" className={classes.supplyIcon6} />
            <img src={DemandIcon} alt="" className={classes.demandIcon6} />
            <DropableLabel
              right={isMobile ? "60%" : "60%"}
              marginTop={isMobile ? "52%" : "68%"}
              rotate={"rotate(0deg)"}
              label={"QUANTITY"}
            />
          </div>
          <CanvasJSChart options = {options}  ref={canvasRef}/>
          <Internationl2
            submitted={submit}
            setAnsweredCorrectly={() => console.log("setAnsweredCorrectly")}
            setAnsweredPartialy={() => console.log("setAnsweredPartialy")}
            questionAnswer={questionsAnswers[qIndex]}
            setAnswers={() => console.log("setAnswers")}
            answers={questionsAnswers[qIndex].answer}


            onSelect={onSelect}
            setOnSelect={setOnSelect}
            selected={selected}
            setSelected={setSelected}
            markSelected={markSelected}
            data={data}
            setChartData={setChartData}
            setAllCorrect={setAllCorrect}
          />

          {/* {submit && (getLabeltext() || getAnswertext()) &&
            <div style={{ display: "flex", top: 0, height: "78%", width: "100%", position: "absolute", zIndex: 1, background: "rgba(152, 152, 152, 0.5)" }}>
            </div>
          } */}
          <div className={classes.buttonContainer6}>
            {
            !submit? (<>
              <button className={classes.buttonSubmit6} onClick={() => submitButtonAction()}>{getButtonText()}</button>
              <button className={classes.clearButton6} onClick={() => clearScreen()}>Clear</button>
              </>) : <button className={classes.nextButton6} onClick={() => handleReloadClick()}>NEXT</button>
            }
          </div>
        </div>
      </div>
    </>
  )

}
export default withStyles(styles)(BubbleAndLine6);
